import React from "react";
import "./homePage.css";

const HomePage = () => {
  return (
    <div className="home-page-msg-container">
      <h1>Hello,</h1>
      <h3>
        This is a platform that sources cryptocurrency market details, news and
        conversations from Reddit.
      </h3>
    </div>
  );
};

export default HomePage;
